import { environment } from "../../config";
import { iTipoObjetivo } from "../../interfaces/SuperAdmin/Others/iDataTipoObjetivos";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL, VERSION } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const getAllTiposObjetivo = () =>
  fetchData<iTipoObjetivo[]>({
    method: "GET",
    url: `${baseApiBroker}/tipo-objetivo`,
  });
